import Bluebird = require("bluebird");
import { inject, injectable } from "inversify";
import TYPES from "../TYPES";
import { ConsoleUI } from "../utils/ConsoleUI";
import { KotennaApi } from "../lib/kotenna/KotennaApi";
import { CloudProvider } from "../lib/kotenna/CloudProvider";
import container from "../inversify.config";
import { CloudProviderWorker } from "../providers/CloudProviderWorker";

declare global { export interface Promise<T> extends Bluebird<T> {} }
Promise = Bluebird as any;

const delay = (time) => (result) => new Promise(resolve => setTimeout(() => resolve(result), time));


@injectable()
export class ProviderWorker {

    private console: ConsoleUI;
    private api: KotennaApi;

    constructor(@inject(TYPES.ConsoleUI) ui: ConsoleUI, @inject(TYPES.KotennaApi) api: KotennaApi ) {
        this.api = api;
        this.console = ui;
    }

    async create(): Promise<CloudProvider> {

        const flavour = await this.console.promptList("Choose a cloud flavour", ["digitalocean", "awsec2", "azure/vm", 'awscf']);
        const worker = container.get<CloudProviderWorker>(TYPES.CloudProvidertWorker(flavour));

        return worker.createProvider().then(provider => {
            this.console.loaderStart(`Saving provider ${provider.name}`);
            return this.api.providerSave(provider);
        });
    }

    async list(): Promise<CloudProvider[]> {
        this.console.loaderStart("Loading CloudProviders")
        return this.api.providers();
    }

}

